import { render, staticRenderFns } from "./DepartmentFilter.vue?vue&type=template&id=5c41c581&scoped=true"
import script from "./DepartmentFilter.vue?vue&type=script&lang=js"
export * from "./DepartmentFilter.vue?vue&type=script&lang=js"
import style0 from "./DepartmentFilter.vue?vue&type=style&index=0&id=5c41c581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c41c581",
  null
  
)

export default component.exports